import React from 'react';
import { makeStyles } from '@material-ui/core';
import { EmailIcon } from '#web-components/components/Icons';

import Typography from '#web-components/components/Typography';
import styles from './LinkMail.styles';

const useStyles = makeStyles(styles, { name: 'Link' });

interface Props {
  email: string;
  subject: string;
  body: string;
}

const LinkMail: React.FC<Props> = ({
  email,
  subject,
  body,
}) => {
  const classes = useStyles();
  const hrefUrl = `mailto:${email}?subject=${subject}&body=${body}`;
  return (
    <a target="_blank" rel="noreferrer" href={hrefUrl} className={classes.link}>
      <EmailIcon />
      <Typography variant="accentTiny" component="span">{email}</Typography>
    </a>
  );
};

export default LinkMail;
